import { defineStore } from 'pinia'
import $api from '@/plugins/axios';

export const useStudentStore = defineStore('StudentStore', {
  state: () => {
    return {
      list: [],
      maxCount: 50,
      activeStudentCount: null,
      totalCount: 0,
      totalPage: 0,
      isInfoDisable: false,
      studentInfo: null,
      subscriptionInfo: null,
      summary: {
        activeStudentCount:0,
        authenticatedStudentCount:0,
        creatableStudentCount:0,
        noneAuthenticatedStudentCount:0
      },
      searchSummary: {
        activeStudentCount:0,
        inactiveStudentCount: 0,
        authenticatedStudentCount:0,
        creatableStudentCount:0,
        noneAuthenticatedStudentCount:0
      },
      pageInfo: {},
      groupSearch: {
        content: [],
        pageInfo: {}
      }
    }
  },
  actions: {
    /** 요금제 인원 가져오기 */
    async getSubscription() {
      try{
        const res = await $api.get(`/subscriptions`);
        this.subscriptionInfo = res;
        this.maxCount = res.userCount;
      } catch(e) {
        this.$handleError(e);
      }
    },
    /** 원생 요약정보 가져오기 */
    async getStudentSummary() {
      try{
        const res = await $api.get('/customers/students/summaries', {});
        this.summary = res;
      } catch(e) {
        this.$handleError(e);
      }
    },
    /** 검색결과 카운트 가져오기 */
    async getStudentCountSummary(params) {
      try{
        const res = await $api.get('/customers/students/summaries', {params});
        this.searchSummary = res;
      } catch(e) {
        this.$handleError(e);
      }
    },
    /** 원생 리스트 가져오기 */
    async getStudents(params) {
      try {
        const res = await $api.get(`/customers/students`, {params});
        this.totalList = res.content;
        this.list = res.content;
        this.pageInfo = {
          totalCount: res.total,
          totalPages: Math.ceil(res.total / res.pageable.size)
        }
      } catch (e) {
        this.$handleError(e);
      }
    },
    /** 원생 리스트 가져오기 */
    async getStudentsForExcel(params) {
      try {
        const res = await $api.get(`/customers/students`, {params});
        return res.content
      } catch (e) {
        this.$handleError(e);
      }
    },
    /** 활성화 된 원생 수 가져오기 */
    async getStudentCount(params) {
      const res = await $api.get('/academies/students/counts', {params})
      this.activeStudentCount = parseInt(res.data);
    },
    /** 원생 활성화 */
    async activateStudent(customerId){
      try {
        await $api.post(`/customers/students/${customerId}/activates`);
      } catch(e) {
        this.$handleError(e);
      } finally {
        this.getSubscription();
      }
    },
    /** 원생 비활성화 */
    async deactivateStudent(customerId){
      try {
        await $api.delete(`/customers/students/${customerId}/activates`);
      } catch(e) {
        this.$handleError(e);
      } finally {
        this.getSubscription();
      }
    },
    /** 원생 가입 */
    async postStudents(params) {
      return await $api.post('/customers/students', params);
    },
    /** 원생 정보조회 */
    async getStudentInfo(customerId) {
      try {
        const res = await $api.get(`/customers/students/${customerId}`);
        this.studentInfo = res;
        return res
      } catch(e) {
        this.$handleError(e);
      }
    },
    async getStudentsByAdmin(params){
      try {
        const res = await $api.get(`/admin/customers/students`, {params});
        this.list = res.content;
        this.pageInfo = {
          totalCount: res.pageInfo?.totalCount,
          totalPages: res.pageInfo?.totalPages
        }
        return res
      } catch(e) {
        this.$handleError(e);
      }
    },
    async postStudentsByAdmin(data){
      try{
        const res = await $api.post('/admin/customers/students', data);
        return res.data;
      }catch(e){
        throw e.response.status;
      }
    },
    /** 원생정보 수정 */
    async patchInfo(params) {
      try {
        await $api.patch(`/customers/students/${params.customerId}`, params);
      } catch (e) {
        this.$handleError(e);
      }
    },
    async postResendEmail(customerId) {
      try{
        await $api.post(`/customers/students/${customerId}/resend-email`);
      }catch(e){
        throw e.response.status;
      }
    },
    async getGroupsAcademies(params){
      try{
        const academies = await $api.get('/admin/groups/academies', {params});
        this.groupSearch.content = academies.content;
        this.groupSearch.pageInfo = academies.pageInfo;
      }catch(e){
        throw e.response.status;
      }
    },
    $handleError(e) {
      this.$nuxt.$sentry.captureException(e);
      this.$nuxt.error({ statusCode: e.response.status });
    }
  },
  getters: {
  }
})
